<template>
    <!-- Only filled by bots -->
    <div class="form-group" style="display: none;">
        <label for="faxonly">Fax Only
            <input type="checkbox" autocomplete="off" tabindex="-1" :name="parameter" :id="parameter" checked="checked" required />
        </label>
    </div>
</template>

<script>
export default {
    name: 'Honeypot',
    components: {
    },
    props: {
        parameter: {
            type: String,
            default: 'honeypot',
        },
    },
    mounted() {
        let checkbox = document.getElementById(this.parameter);
        if(checkbox) {
            checkbox.removeAttribute("checked");
            checkbox.removeAttribute("required");
        };
    },
};
</script>